module.exports = __webpack_public_path__ + "static/osteomap-9f9d307c858f2dc11faa3ebb18c629dc.png";